import { Subtitle2Text } from '@/utils/global-fonts';
import PropTypes from 'prop-types';
import { BsFileEarmarkArrowUp } from 'react-icons/bs';
import styled from 'styled-components';
import { Row } from '../grid/grid-component';

const ProgressBarContainer = styled.div`
  width: 100%;
  background-color: #ddd;
  border-radius: 20px;
  overflow: hidden;
`;

const ProgressBar = styled.div`
  height: 20px;
  background-color: ${(props) => props.color || '#007bff'};
  width: ${(props) => (props.progress > 100 ? '100%' : `${props.progress}%`)};
`;

const ProgressBarText = styled.div`
  color: #58595b;
  font-size: 12px;
  text-align: end;
  line-height: 20px;
`;

const FileUploadDiv = styled.div`
  background: #f5f6fa;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  width: 40px;
  height: 40px;
  margin-right: 16px;
`;

const styledRow = {
  margin: 0,
  alignContent: 'center',
  paddingLeft: 0,
  paddingRight: 0,
};

const styledProgressBarRow = {
  margin: 0,
  paddingRight: 48,
};

/**
 * @param {object} root0 - Root object containing props
 * @param {number} root0.progress - Progress value
 * @param {string} root0.color - Color for progress bar
 * @param {string} root0.fileName - File name
 * @returns {JSX.Element} - React component
 */
const Progress = ({ progress, color, fileName }) => (
  <Row style={styledRow} align="center" justify="between" wrap="nowrap">
    <FileUploadDiv>
      <BsFileEarmarkArrowUp size={30} />
    </FileUploadDiv>
    <Row
      style={styledProgressBarRow}
      align="stretch"
      justify="center"
      wrap="nowrap"
      direction="column"
    >
      <Subtitle2Text color="black">{fileName}</Subtitle2Text>
      <ProgressBarContainer>
        <ProgressBar progress={progress} color={color} />
      </ProgressBarContainer>
      <ProgressBarText>uploading...{progress}%</ProgressBarText>
    </Row>
  </Row>
);
Progress.defaultProps = {
  progress: 0,
  color: '#007bff',
  fileName: 'Some File name',
};

Progress.propTypes = {
  progress: PropTypes.number,
  color: PropTypes.string,
  fileName: PropTypes.string,
};

export default Progress;
